(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('calendar', ['HelperService', CalendarDirectiveFn]);

    /* directive for handling calendar input */
    function CalendarDirectiveFn(HelperService) {
        var directive = {
            link: link,
            scope: {
                date: '=',
                required: '@',
                name: '@',
                format: '@',
                time: '@?',
                position: '@?'      // possible values (default is auto): top, bottom, auto 
            },
            restrict: 'E',
            templateUrl: '/app/global/templates/rf-global-calendar.template.html'
        };
        return directive;

        function link(scope, element) { 
            
            // workaround for option allowInputToggle not working: https://github.com/tempusdominus/bootstrap-4/issues/80
            // Custom focus/blur handlers
            $(document).on('focus.datetimepicker', '.datetimepicker-input', function () {
                $(this).parent().datetimepicker('show', $(this).parent().data('datetimepicker'));
            });
            $(document).on('blur.datetimepicker', '.datetimepicker-input', function () {
                $(this).parent().datetimepicker('hide', $(this).parent().data('datetimepicker'));
            });
            
            // date to interact with picker
            scope.interact = scope.date;
            
            // format
            var format = HelperService.getLocalDateFormat(scope.time && scope.time === 'true');
            scope.format = format;

            var position = scope.position || 'auto';

            // options of picker
            scope.options = {
                locale: moment.locale(),
                format: format,
                showClear: true,
                showTodayButton: true,
                allowInputToggle: true,     // option not working, see https://github.com/tempusdominus/bootstrap-4/issues/80
                widgetPositioning: {
                    horizontal: 'auto',
                    vertical: position
                 }            
            };
            
            scope.changed = function () {
                scope.date = scope.interact 
                                    ? HelperService.isoDateWithoutZoneFromMoment(scope.interact)
                                    : null;                
            };

            scope.$on('$destroy', function () {
                scope.interact = null;
                format = null;
                scope.options = null;                
            });
        }
    }
})();